import { isSSR } from 'app/packages/components';

/**
 * @deprecated переезжаем на yandex.cloud, как только полностью переедем - нужно будет выпилить эту функцию
 * Сейчас не все иконки перенесены в облако, а именно, иконки турниров. Поэтому, как появятся, тогда нужно будет выпилить эту функцию
 */
export const composeImageSrcFromCDN = (
  entity: string,
  size: number,
  entityId: number,
): string => {
  const prefix = isSSR ? process.env.CDN_SERVER_URL : window.__env.CDN_SERVER_URL;

  return `${prefix}/${entity}/${size}/${entityId}.png`;
};
